import Swiper from "swiper";
import { find } from "utils/dom";

export default function () {
	const Home = find("[js-page='home']");
	if (!Home) return;

	document.addEventListener('DOMContentLoaded', function () {
		const swiperEmpresa = new Swiper('.swiper-empresa', {
			slidesPerView: 1.2,
			centeredSlides: false,
			speed:1000,
			spaceBetween: 24,
			navigation: {
				nextEl: '.swiper-empresa .company-button-next',
				prevEl: '.swiper-empresa .company-button-prev',
			},
			breakpoints: {
				767: { 
					slidesPerView: 1
				}
			}	
		});

		const swiperParceirosHome = new Swiper(".swiper-parceiros-home", {
			spaceBetween: 20,
			slidesPerView: 'auto',
			loop: true,
			speed: 3000,
	
			autoplay: {
				delay:1,
				disableOnInteraction: false
			},
		});

		const swiperClientes = new Swiper('.swiper-clientes', {
			slidesPerView: 'auto',
			centeredSlides: false,
			speed:1000,
			spaceBetween: 24,
			navigation: {
				nextEl: '.customers-container .client-button-next',
				prevEl: '.customers-container .client-button-prev',
			},
			pagination: { 
        el: '.swiper-pagination-testimonial',
        type: 'fraction',
			}
		});

		const swiperChoice = new Swiper('.swiper-choice', {
			slidesPerView: 'auto',
			centeredSlides: false,
			speed:1000,
			spaceBetween: 20,
			navigation: {
				nextEl: '.home-choice-container .choice-button-next',
				prevEl: '.home-choice-container .choice-button-prev',
			},
			pagination: { 
        el: '.swiper-pagination-choice',
				type: 'fraction',
				formatFractionCurrent: (number) => number.toString(),
				formatFractionTotal: (number) => number.toString()
			},
			breakpoints: {
				768: { 
					slidesPerView: 3
				}
			}	
		});

	});

	const estados = document.querySelectorAll('[data-id-estado]')
	const statesRight = document.querySelectorAll('.ul-states li')


	const estadosDisponiveis = new Set(
  		[...statesRight].map(li => li.dataset.liEstado)
		)

		estados.forEach(estado => {
		const nome = estado.dataset.idEstado

		if (estadosDisponiveis.has(nome)) {
			estado.classList.add('disponivel')
		} else {
			estado.classList.remove('disponivel')
		}
		})

	const resetLista = () => {
	statesRight.forEach(li => {
		li.querySelector('p')?.classList.remove('text-active')
		li.querySelector('svg')?.classList.add('opacity-0')
	})
	}

	const resetMapa = () => {
  estados.forEach(e => e.classList.remove('active'))
}

	const ativaEstado = (id) => {
		const li = document.querySelector(`[data-li-estado="${id}"]`)
		const estado = document.querySelector(`[data-id-estado="${id}"]`)

		if (li) {
			li.querySelector('p')?.classList.add('text-active')
			li.querySelector('svg')?.classList.remove('opacity-0')
		}

		if (estado) {
			estado.classList.add('active')
		}
		}

	estados.forEach(estado => {
		estado.addEventListener('mouseenter', () => {
			resetLista()
			ativaEstado(estado.dataset.idEstado)
		})

		estado.addEventListener('mouseleave', () => {
			resetLista()
			resetMapa()
		})
		})   

	statesRight.forEach(li => {
			li.addEventListener('click', () => {
				resetLista()       
				resetMapa()
				ativaEstado(li.dataset.liEstado)
			})
		})

		const select = document.querySelector('.map-select')
		const paises = document.querySelectorAll('[data-pais]')

		select?.addEventListener('change', e => {
		paises.forEach(pais => {
			pais.classList.toggle(
			'hidden',
			pais.dataset.pais !== e.target.value
			)
		})
	})


	// changeStates()
	// changeStatesactive()
	// changeSelect()
}
